export default {
  Products: "Products",
  Rolls: "Rolls"
};



// WEBPACK FOOTER //
// ./src/components/BillOfLading/ViewTypes.js